<template>
  <footer>
    <p>{{ $t("footer.rights") }}</p>
    <div class="social-links">
      <a href="https://www.snapchat.com/add/scrubpoint" target="_blank"><i class="fab fa-snapchat"></i></a>
      <a href="https://www.instagram.com/scrub_point/" target="_blank"><i class="fab fa-instagram"></i></a>
    </div>

    <div class="emails">
      <a href="mailto:management@scrub-point.com">
        <i class="fas fa-envelope"></i> management@scrub-point.com
      </a>
      <a href="mailto:sales@scrub-point.com">
        <i class="fas fa-envelope"></i> sales@scrub-point.com
      </a>
    </div>
  </footer>
</template>

<script>
export default { name: "FooterSection" };
</script>
